import { Injectable } from '@angular/core';
import { LocalizationService } from '../settings/localization.service';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class LocalizationDataService {
  private currentLanguage = new BehaviorSubject<string>(this.language); // Initialize with current login status
  currentLanguage$ = this.currentLanguage.asObservable();
  localizations: any;
  constructor(private localizationService: LocalizationService, private translate: TranslateService) {
    if (!this.localizations) {
      this.getLocalizations();
    }
  }

  getLocalizations() {
    this.localizationService.getLocalization().subscribe((res: any) => {
      this.localizations = res;
      this.setLocale(this.language); // Example to set locale to French
    });
  }

  get languages() {
    return this.localizations?.languages;
  }

  get currency() {
    return this.localizations?.local_currency;
  }

  get language() {
    return this.localizations?.local_language;
  }

  setLocale(lang: any) {
    this.currentLanguage.next(lang)
    this.translate.setDefaultLang(lang.code || 'en');
  }
}
